import { useAuthStore } from '@/features/auth/store';

export const useAuth = () => {
  const { user, isAuthenticated, error } = useAuthStore(state => state);
  const { login, logout, clearError, checkAuth, isLoading } = useAuthStore(
    state => state.actions
  );

  return {
    user,
    isLoading: isLoading(), // Use the computed helper method
    isAuthenticated,
    error,
    login,
    logout,
    clearError,
    checkAuth,
  };
};
